import React from 'react';
import { Banner } from 'components';

interface ExpirationBannerProps {
  daysRemaining: number;
  isExpired: boolean;
}

export const ExpirationBanner = ({
  isExpired,
  daysRemaining,
}: ExpirationBannerProps) => {
  return (
    <>
      {!isExpired && daysRemaining > 0 && daysRemaining < 7 && (
        <Banner
          text={`This quote expires in ${daysRemaining} days.`}
          variant='warning'
        />
      )}
      {isExpired && (
        <Banner
          text='This quote has expired.'
          variant='error'
          disableIcon={true}
        />
      )}
    </>
  );
};
